<script setup lang="ts">
import { computed } from 'vue'
import * as formatNumber from '@/helpers/numberFormatters'
import type { LoginSectionProps, SeminarContext } from '../useLoginSection'

const props = defineProps<LoginSectionProps & { context: SeminarContext, currentSection: string }>()

const currentStep = computed(() => {
  switch (props.currentSection) {
    case props.LoginSection.SignupProfileForm:
      return 0
    case props.LoginSection.EmailVerification:
      return 1
    case props.LoginSection.RedirectLoader:
      return 2
    default:
      return 0
  }
})

function formatPrice(val?: number) {
  if (!val) return '—'
  return formatNumber.price.rub(val)
}
</script>

<template>
  <div class="login-smartbook-sidebar">
    <span class="login__aside-text"> Покупка семинара </span>

    <div class="login-smartbook-sidebar__card pa-3 mt-4">
      <div class="d-flex text-title-bold">
        <span class="flex-spacer mr-2"> Семинар {{ context.seminar?.seminar_name }} </span>
        <span>
          {{ formatPrice(context.seminar?.price) }}
        </span>
      </div>
    </div>

    <ol class="login-smartbook-sidebar__card login-smartbook-sidebar__stepper mt-2 pa-2">
      <li :active="currentStep > 0">
        <p class="text-body-bold">Регистрация</p>
        <p class="gray-text mt-1">Войдите на сайт или создайте аккаунт учителя</p>
      </li>

      <li :active="currentStep > 1">
        <p class="text-body-bold">Подтверждение почты</p>
        <p class="gray-text mt-1">Введите код подтверждения, отправленный на вашу почту</p>
      </li>

      <li>
        <p class="text-body-bold">Оплата</p>
        <p class="gray-text mt-1">
          После оплаты семинар будет доступен в разделе "Семинары и курсы" на сайте МирГоворит
        </p>
      </li>
    </ol>
  </div>
</template>

<style lang="scss">
.login-smartbook-sidebar {
  &__card {
    border-radius: 8px;
    background: white;
    box-shadow:
      0px 8px 16px 0px rgba(black, 0.05),
      0px 2px 8px rgba(black, 0.1);

    max-width: 550px;
  }

  &__stepper {
    & > li {
      display: list-item;
      margin-left: 32px;
      position: relative;
      padding: 16px;

      &[active] + li:not([active]),
      &:not([active]):first-child {
        background: rgba($blue, 0.05);
        border-radius: 8px;

        &::before {
          background: rgba($blue, 0.3);
          color: $blue;
        }
      }

      &[active] {
        &::before {
          background: rgba($green, 0.3);
          color: $green;
          content: '✓';
        }
      }

      & + li {
        margin-top: 8px;
      }

      &::before {
        left: -32px;
        position: absolute;

        content: counters(list-item, '.');
        width: 24px;
        height: 24px;
        display: inline-block;
        text-align: center;
        border-radius: 4px;

        background: rgba($gray, 0.3);
        color: $gray;
      }

      &:not(:last-child)::after {
        content: ' ';
        display: block;
        width: 1.5px;
        height: calc(100% - 28px);
        background: $lightGray;
        position: absolute;
        left: -20px;
        top: 47px;
        border-radius: 4px;
      }
    }
  }
}
</style>
